export const BODY_COPY =
  "We'll show you the required trainings you need to complete based on your selections above."
export const COMPLETED_BUTTON_TEXT = 'START TRAINING'
export const FORWARD_BUTTON_TEXT = 'CONTINUE'
export const HEADER_TEXT = "You're all set"
export const PREVIOUS_BUTTON_TEXT = 'BACK'
